import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchExpertiseAttachments, fetchExpertiseAttachmentsError, fetchExpertiseAttachmentsSuccess } from './actions';

import { DetailsExpertiseAttachmentActionTypes } from './types';
import { getExpertiseAttachments } from '../../utils/api/documentsApi';
import { SagaIterator } from 'redux-saga';

function* handleFetchExpertiseAttachments(action: ReturnType<typeof fetchExpertiseAttachments>): SagaIterator {
  try {
    const res = yield call(getExpertiseAttachments, action.payload.instructionId);

    if (!res.data) {
      yield put(fetchExpertiseAttachmentsError(JSON.stringify(res.response)));
    } else {
      yield put(fetchExpertiseAttachmentsSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchExpertiseAttachmentsError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(fetchExpertiseAttachmentsError('An unknown error occured.'));
    }
  }
}

function* watchExpertiseAttachmentsDetails() {
  yield takeEvery(DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS, handleFetchExpertiseAttachments);
}

function* detailsExpertiseAttachmentSaga() {
  yield all([fork(watchExpertiseAttachmentsDetails)]);
}

export default detailsExpertiseAttachmentSaga;
